import React from 'react';
import UniversalIconBtn from '../headless/button/UniversalIconBtn';
import styled from 'styled-components';
import { useEditMode } from '../../hooks/useEditMode';
import { DeviceType, SelectType, WorkType } from '../../enum/EnumRepository';
import { StyledDivComponent } from '../../dto/StyleCompRepository';
import SelectBox from '../SelectBox';
import { OrgWrapper } from './OrgDescription';
import searchIcon from '../../../asset/icon/see.png';
import searchNotIcon from '../../../asset/icon/see_not.png';
import { useDeviceStore } from '../../store/deviceStore';
import HintSmallWrapper from '../headless/button/HintSmallWrapper';
import { getHintMessage } from '../../constants/hintMessages';

interface OrgSelectDivVisiProps {
  value: WorkType;
  selectType: SelectType;
  handleChange: (value: WorkType) => void;
  StyledDiv: StyledDivComponent;
  visible: boolean;
  changeVisible: () => void;
  changeVisibleMobile?: () => void;
}

const OrgSelectDivVisi: React.FC<OrgSelectDivVisiProps> = ({
  value,
  selectType,
  handleChange,
  StyledDiv,
  visible,
  changeVisible,
  changeVisibleMobile,
}) => {
  const { isEditMode } = useEditMode();
  const { deviceType } = useDeviceStore();

  return (
    <>
      {isEditMode ?
        <OrgWrapper>
          <SelectBoxWrapper $isVisible={visible}>
            <SelectBox
              value={value}
              selectType={selectType}
              handleChange={handleChange}
              direction={false} />
          </SelectBoxWrapper>
          <HintSmallWrapper content={visible ? getHintMessage('SET_TO_PRIVATE') : getHintMessage('SET_TO_PUBLIC')} toLeft={true}>
            <UniversalIconBtn
              size="fit"
              border={false}
              isTransparent
              backgroundImg={visible ? searchIcon : searchNotIcon}
              onClick={deviceType === DeviceType.MOBILE ? changeVisibleMobile : changeVisible}
            />
          </HintSmallWrapper>
        </OrgWrapper>
        : (
          visible ?
            <StyledDiv>{value}</StyledDiv>
            :
            null
        )
      }
    </>
  );
};

export const SelectBoxWrapper = styled.article<{ $isVisible: boolean }>`
  width: clamp(90px, 6vw, 120px);
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0.5)};
`;

export default OrgSelectDivVisi;
